import LandingPage from "../assets/templates/landingPage";

const Home = () => <LandingPage />;

export default Home;